import axios from './Axios';
import { error, success } from "./ResponseHandler";

const { REACT_APP_BASE_API_URL } = process.env;
const HELLO = `${REACT_APP_BASE_API_URL}/api/base/hello`;

class NetworkService {
    async testNetworkStatus() {
        try {
            const response = await axios.get(HELLO, {
                timeout: 30000 // 30 seconds timeout
            });
            return success(response);
        } catch (e) {
            return error(e);
        }
    }
}

export default new NetworkService();
